/** Query keys, status lists and the slot other modules use to add tabs to the vendor page. */

import type { VendorStatusEnum } from "@motolynk/api-client";

export const vendorKeys = {
  all: ["admin", "vendors"] as const,
  list: (params: object) => ["admin", "vendors", "list", params] as const,
  counts: () => ["admin", "vendors", "counts"] as const,
  detail: (uid: string) => ["admin", "vendors", "detail", uid] as const,
  platform: () => ["admin", "vendors", "platform"] as const,
  history: (uid: string) => ["admin", "vendors", "history", uid] as const,
  overrides: (uid: string) => ["admin", "vendors", "overrides", uid] as const,
};

export const STATUS_TABS = [
  "pending",
  "under_review",
  "approved",
  "suspended",
  "rejected",
  "draft",
  "all",
] as const;

export type StatusTab = (typeof STATUS_TABS)[number];

/** Statuses an admin can still decide on. */
export const REVIEWABLE: VendorStatusEnum[] = ["pending", "under_review"];

/**
 * Tabs other modules add to the vendor page (products, orders, payouts…):
 * `admin.slots["vendor.tabs"] = [{ id, label, permission, component: (props: VendorTabProps) => … }]`.
 */
export const VENDOR_TABS = "vendor.tabs";

export interface VendorTabProps {
  vendorUid: string;
}
